export default __webpack_public_path__ + "static/media/sheersho.7eea4699.jpg";